import React from 'react';
import { FlagIconProps, GenericFlagIcon } from './GenericFlagIcon';
/** ![](data:image/svg+xml;base64,PHN2ZyAgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiB2aWV3Ym94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+CiAgICAgIDxwYXR0ZXJuIGlkPSJncmlkIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgIDxyZWN0IGZpbGw9IiNkNGQ1ZGEiIHg9IjAiIHk9IjAiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiLz4KICAgICAgICA8cmVjdCBmaWxsPSIjZjdmN2Y3IiB4PSI4IiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ii8+CiAgICAgICAgPHJlY3QgZmlsbD0iI2Q0ZDVkYSIgeD0iOCIgeT0iOCIgd2lkdGg9IjgiIGhlaWdodD0iOCIgLz4KICAgICAgICA8cmVjdCBmaWxsPSIjZjdmN2Y3IiB4PSIwIiB5PSI4IiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ii8+CiAgICAgIDwvcGF0dGVybj4KICAgIDwvZGVmcz4KICAgIDxyZWN0IGZpbGw9InVybCgjZ3JpZCkiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgMjhjNi42MjcgMCAxMi01LjM3MyAxMi0xMkg0YzAgNi42MjcgNS4zNzMgMTIgMTIgMTJ6IiBmaWxsPSIjZmZmIj48L3BhdGg+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOCAxNmMwLTYuNjI3LTUuMzczLTEyLTEyLTEyUzQgOS4zNzMgNCAxNmgyNHoiIGZpbGw9InJlZCI+PC9wYXRoPjxwYXRoIGQ9Ik0xNiAyOUM4LjgyIDI5IDMgMjMuMTggMyAxNlM4LjgyIDMgMTYgM3MxMyA1LjgyIDEzIDEzLTUuODIgMTMtMTMgMTN6IiBzdHJva2U9IiNFMUU1RTciIHN0cm9rZS13aWR0aD0iMiI+PC9wYXRoPjwvc3ZnPg==) */
export function FlagInd(props: FlagIconProps) {
  return (
    <GenericFlagIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28C22.6274 28 28 22.6274 28 16H4C4 22.6274 9.37258 28 16 28Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16H28Z"
        fill="#FF0000"
      />
    </GenericFlagIcon>
  );
}
